var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBorderStyleSolid = function SvgBorderStyleSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5v22h4v-2H7V7h18v2h2V5H5m20 6v4h2v-4zm0 6v4h2v-4zm0 6v2h-2v2h4v-4zm-14 2v2h4v-2zm6 0v2h4v-2z"
  })));
};
export default SvgBorderStyleSolid;